module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion-up.58631fd5.png";